import { AbstractControl, ValidatorFn } from "@angular/forms";
import * as moment from "moment";

export function dateLessThenValidator(otherControlName: string, allowEqual: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

        if (!control.parent || !control.value) {
            return null;
        }

        const otherControl = control.parent.get(otherControlName) as AbstractControl;

        if (!otherControl) {
            throw new Error("dateLessThenValidator(): other control is not found in parent group");
        }

        if (!control["subscribed"]) {
            control["subscribed"] = true;

            otherControl.valueChanges.subscribe(() => {
                control.updateValueAndValidity();
            });
        }

        if ((allowEqual && moment(otherControl.value).format("YYYY-MM-DD") < moment(control.value).format("YYYY-MM-DD")) || (!allowEqual && moment(otherControl.value).format("YYYY-MM-DD") <= moment(control.value).format("YYYY-MM-DD"))) {
            return { "dateSmaller": true };
        }
        return null;
    };
}

export function dateGreaterThenValidator(otherControlName: string, allowEqual: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

        if (!control.parent) {
            return null;
        }

        const otherControl = control.parent.get(otherControlName) as AbstractControl;

        if (!otherControl) {
            throw new Error("dateGreaterThenValidator(): other control is not found in parent group");
        }

        if (!control["subscribed"]) {
            control["subscribed"] = true;

            otherControl.valueChanges.subscribe(() => {
                control.updateValueAndValidity();
            });
        }

        if (otherControl.value && ((allowEqual && moment(otherControl.value).format("YYYY-MM-DD") > moment(control.value).format("YYYY-MM-DD")) || (!allowEqual && moment(otherControl.value).format("YYYY-MM-DD") >= moment(control.value).format("YYYY-MM-DD")))) {
            return { "dateGreater": true };
        }
        return null;
    };
}
